import React, { HTMLAttributes } from "react";
import { VariantProps, cva } from "class-variance-authority";
import { cn } from "@core/lib/utils";

export const surfaceVariants = cva(
  "border rounded-container p-4",
  {
    variants: {
      variant: {
        primary: "bg-primary-100 dark:bg-primary-900 border-primary-200 dark:border-primary-800 dark:text-white",
        secondary: "bg-secondary-100 dark:bg-secondary-900 border-secondary-200 dark:border-secondary-800 dark:text-white",
        info: "bg-info-100 dark:bg-info-900 border-info-200 dark:border-info-800 dark:text-white",
        success: "bg-success-100 dark:bg-success-900 border-success-200 dark:border-success-800 dark:text-white",
        warning: "bg-warning-100 dark:bg-warning-900 border-warning-200 dark:border-warning-800 dark:text-white",
        danger: "bg-danger-100 dark:bg-danger-900 border-danger-200 dark:border-danger-800 dark:text-white",
        surface: "bg-surface-50 dark:bg-surface-900 border-surface-100 dark:border-surface-800 dark:text-white",
        outline: "bg-transparent border-surface-100 dark:border-surface-900 dark:text-white",
        ghost: "bg-transparent border-none dark:text-white"
      },
    },
    defaultVariants: {
      variant: "surface",
    },
  }
);

export type SurfaceProps =
  HTMLAttributes<HTMLDivElement> & VariantProps<typeof surfaceVariants>

export const Surface = React.forwardRef<HTMLDivElement, SurfaceProps>(
  ({ className, variant, children, ...props }, ref) => {
    return (
      <div className={cn(surfaceVariants({ variant, className }))} ref={ref} {...props}>
        {children}
      </div>
    );
  }
);
Surface.displayName = "Surface";
